import { types } from './actions';

const initialState = {
  isSecretFetching: false,
  isVerifying: false,
  qrCodeUri: null,
  secret: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.TWO_FACTOR_AUTH_SECRET_REQUEST:
      return { ...state, isFetching: true };
    case types.TWO_FACTOR_AUTH_SECRET_SUCCESS:
      return {
        ...state,
        isFetching: false,
        secret: action.payload.secret,
        qrCodeUri: action.payload.uri,
      };
    case types.TWO_FACTOR_AUTH_VERIFY_TOKEN_REQUEST:
      return { ...state, isFetching: true };
    case types.TWO_FACTOR_AUTH_VERIFY_TOKEN_SUCCESS:
      return { ...state, isFetching: false, secret: null };
    case types.TWO_FACTOR_AUTH_VERIFY_TOKEN_ERROR:
      return { ...state, isFetching: false };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => {
  return state.modules.settings.userProfile.twoFactorAuth;
};

export const getIsFetching = (state) => {
  return getScope(state).isFetching;
};

export const getSecret = (state) => {
  return getScope(state).secret;
};

export const getQrCodeUri = (state) => {
  return getScope(state).qrCodeUri;
};

export const getIsVerifying = (state) => {
  return getScope(state).isVerifying;
};
